module.exports = __webpack_public_path__ + "img/b1.886968e4.png";